import { render } from "./DeclarationPerteModal.vue?vue&type=template&id=7edaf123&scoped=true"
import script from "./DeclarationPerteModal.vue?vue&type=script&lang=js"
export * from "./DeclarationPerteModal.vue?vue&type=script&lang=js"

import "./DeclarationPerteModal.vue?vue&type=style&index=0&id=7edaf123&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7edaf123"]])

export default __exports__